var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{class:_vm.maxContent ? 'max-content skeleton' : 'skeleton'},[_c('span',{staticClass:"hidden"},[_vm._t("default")],2)]):_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }